import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/audiobook/CompleteMakeAudioBook.scss";
import useAppTranslation from "../../hooks/useAppTranslation";

const CompleteMakeAudioBook = ({ audioBookInfo, onClose }) => {
  const { t } = useAppTranslation("components/audiobook/completeMakeAudioBook");
  const navigate = useNavigate();

  const randomChars = [
    "/images/audiobook/complete-nikki.svg",
    "/images/audiobook/complete-arial.svg",
  ];

  const randomChar = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * randomChars.length);
    return randomChars[randomIndex];
  });

  return (
    <div className="complete-audio-modal">
      <div className="inner">
        <figure className="random-char">
          <img src={randomChar} alt="" />
        </figure>
        <h2>{t("title")}</h2>
        <div className="button-group">
          <button
            className="listen-btn"
            onClick={() => {
              if (audioBookInfo?.audiobook_id) {
                onClose();
                navigate("/audio-reading", {
                  state: {
                    bookID: audioBookInfo.book_id,
                    pageName: "myStorybook",
                  },
                });
              } else {
                alert(t("alerts.missingInfo"));
              }
            }}
          >
            <img src={"/images/utils/headphones.svg"} alt={t("actions.listen")} />
            <span>{t("actions.listen")}</span>
          </button>
          <button
            className="go-library-btn"
            onClick={() => {
              onClose();
              navigate("/myStorybook");
            }}
          >
            <img
              src={"/images/utils/modal/refresh.svg"}
              alt={t("actions.backToLibrary")}
            />
            <span>{t("actions.backToLibrary")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteMakeAudioBook;
